export default __webpack_public_path__ + "static/media/x33-logo-cny.80919454.png";